import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BASE_URL from '../config';
import Swal from 'sweetalert2';
import SidebarRFQ from '../POpage/SidebarRFQ';





 
  
 

const SupplierRFQ = () => {
  const [rfqData, setRfqData] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const user = JSON.parse(localStorage.getItem("userdata"));


  useEffect(() => {
    fetchRFQData();
  }, []);

  const fetchRFQData = () => {
    axios.get(`${BASE_URL}/api/get-rfq-data`)
      .then((response) => {
        setRfqData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching RFQ data:', error);
      });
  };

  const statusStyles = {
    "RFQ Sent": "bg-info text-white",
    "Supplier Quote received": "bg-primary text-white",
    "Quote submitted to Client": "bg-success text-white",
    "Quote not Received From Supplier": "bg-danger text-white",
    "Under clarification": "bg-warning text-dark",
  };
  
  const bidStatusStyles = {
    "Won": "bg-success text-white",
    "Lost": "bg-danger text-white",
    "Onhold": "bg-secondary text-white",
  };
  
  const handleStatusToggle = async (id, newValue, field) => {
    try {
      await axios.put(`${BASE_URL}/api/update-rfq/${id}`, {
        [field]: newValue,
      });
      fetchRFQData();
      Swal.fire("Updated", `${field} updated successfully`, "success");
    } catch (error) {
      console.error("Failed to update:", error);
      Swal.fire("Error", "Failed to update status", "error");
    }
  };

  // Normalize and group buyers (case insensitive)
  const buyerMap = {};
  rfqData.forEach(item => {
    const lower = item.client_name?.toLowerCase();
    if (lower && !buyerMap[lower]) {
      buyerMap[lower] = item.client_name; // preserve first casing seen
    }
  });
  const uniqueBuyers = Object.values(buyerMap);

  const filteredData = selectedBuyer
    ? rfqData.filter(item => item.client_name?.toLowerCase() === selectedBuyer.toLowerCase())
    : [];

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const getPaginationGroup = () => {
    let start = Math.floor((currentPage - 1) / 5) * 5;
    return new Array(Math.min(5, totalPages - start)).fill().map((_, i) => start + i + 1);
  };

  return (
    <div className="row">
      <div className="custom-2-5">

              <SidebarRFQ />
              </div>
      <div className="custom-9-5 dashboardsclooer p-4">
        <h2 className="text-xl font-bold mb-4">Supplier RFQ</h2>

        <div className="form-group mb-4">
          <label htmlFor="buyerSelect">Select Client Name</label>
          <select
            className="form-control"
            id="buyerSelect"
            style={{ height: '50px' }}
            value={selectedBuyer}
            onChange={(e) => {
              setSelectedBuyer(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">-- Select Client Name --</option>
            {uniqueBuyers.map((buyer, idx) => (
              <option key={idx} value={buyer}>{buyer}</option>
            ))}
          </select>
        </div>

        {selectedBuyer && (
          <>
            <div className="table-responsive" style={{ background: '#fff' }}>
            <table className="table table-borderless custom-table">
              <thead>
                <tr>
                  <th>RFQ Number</th>
                  <th>RFQ Received date </th>
                  <th>Client </th>
                  <th>Client Contact</th>
                  <th>Client Email</th>
                  <th>RFQ Closing Date</th>
                  {/* <th>Fulfillment (Flow)</th> */}
                  <th>Products</th>
                  <th>Status</th>
                  <th>Quote Submit Date</th>
                  <th>MANUFACTURER/SUPPLIER</th>
                  <th>Assigned Status</th>
                  <th>Client Feedback</th>
                  <th>Bid Status</th>
                  <th>If lost/Reason</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((rfq, index) => (
                  <tr key={index}>
                    <td>{rfq.rfq_number || '-'}</td>
                    <td>{rfq.rfq_date || '-'}</td>
                    <td>{rfq.client_name || '-'}</td>
                    <td>{rfq.client_contact || '-'}</td>
                    <td>{rfq.client_email || '-'}</td>
                    <td>{rfq.closing_date || '-'}</td>
                    
                    {/* <td>
                      <div className="d-flex justify-content-between fulfillment-flow">
                        <div className="flow-step completed">
                          <div className="bar"></div>
                          <small>Responded</small>
                        </div>
                        <div className="flow-step completed">
                          <div className="bar"></div>
                          <small>Evaluated</small>
                        </div>
                        <div className="flow-step pending">
                          <div className="bar"></div>
                          <small>Awarded</small>
                        </div>
                      </div>
                    </td> */}
                    <td>{rfq.products || '-'}</td>
                    <td>
  <select
    className={`form-select form-select-sm ${statusStyles[rfq.status] || ''}`}
    value={rfq.status}
    onChange={(e) => handleStatusToggle(rfq.id, e.target.value, 'status')}
  >
    <option value="">Select</option>
    <option value="RFQ Sent">RFQ Sent</option>
    <option value="Supplier Quote received">Supplier Quote received</option>
    <option value="Quote submitted to Client">Quote submitted to Client</option>
    <option value="Quote not Received From Supplier">Quote not Received From Supplier</option>
    <option value="Under clarification">Under clarification</option>
  </select>
</td>



                    <td>{rfq.quote_submit_date || '-'}</td>
                    <td>{rfq.manufacturer_supplier || '-'}</td>
                    <td>{rfq.assigned_staff || '-'}</td>
                    <td>{rfq.client_feedback || '-'}</td>
                    <td>
  <select
    className={`form-select form-select-sm ${bidStatusStyles[rfq.bid_status] || ''}`}
    value={rfq.bid_status}
    onChange={(e) => handleStatusToggle(rfq.id, e.target.value, 'bid_status')}
  >
    <option value="">Select</option>
    <option value="Won">Won</option>
    <option value="Lost">Lost</option>
    <option value="Onhold">Onhold</option>
  </select>
</td>
                    <td>{rfq.if_lost || '-'}</td>
                   
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="mt-3 d-flex justify-content-center">
              <nav>
                <ul className="pagination">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>
                      &laquo;
                    </button>
                  </li>

                  {getPaginationGroup().map((pageNumber) => (
                    <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(pageNumber)}>
                        {pageNumber}
                      </button>
                    </li>
                  ))}

                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>
                      &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
          </>
        )}
      </div>
    </div>
  );
};

export default SupplierRFQ;

  
